/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gender__F1Inputs */

const en_gender__f1 = /** @type {(inputs: Gender__F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Female`)
};

/**
* | output |
* | --- |
* | "Female" |
*
* @param {Gender__F1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const gender__f1 = /** @type {((inputs?: Gender__F1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gender__F1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_gender__f1(inputs)
});
export { gender__f1 as "gender__F" }